<template>
  <el-dialog title="层站设置" :visible.sync="dialogVisible" width="640px" :close-on-click-modal="false" :before-close="handleCancel">
    <el-form :model="form" label-width="120px" size="small">
      <el-form-item label="最低层数">
        <el-input v-model.trim="form.minFloor" placeholder="请输入整数（支持负数）"></el-input>
      </el-form-item>

      <el-form-item label="层门总数">
        <!-- <el-input v-model.trim="form.totalDoors" placeholder="请输入整数" disabled></el-input> -->
        <el-input v-model.trim="form.totalDoors" placeholder="请输入整数" ></el-input>
      </el-form-item>

      <el-form-item label="层门类型">
        <el-radio-group v-model="form.doorType">
          <el-radio label="normal">普通门</el-radio>
          <el-radio label="through">贯通门</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="开门方式">
        <el-radio-group v-model="form.openType">
          <el-radio label="center">中分门</el-radio>
          <el-radio label="side">旁开门</el-radio>
          <el-radio label="other">其他</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="轿门锁">
        <el-radio-group v-model="form.carDoorLock">
          <el-radio label="yes">有</el-radio>
          <el-radio label="no">无</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="handleGenerate">生成层站编号</el-button>
      </el-form-item>

      <el-form-item label="层门编号">
        <el-input v-model="form.floorDoorNumbers" placeholder="点击“生成层站编号”自动生成"></el-input>
      </el-form-item>

      <el-form-item label="检查层站">
        <el-input v-model="form.checkStations" placeholder="点击“生成层站编号”自动填充（可手动修改），多个层站用 / 分隔"></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button type="primary" @click="handleSave">保 存</el-button>
    </div>
  </el-dialog>
</template>

<script>
// 弹窗表单默认值：保证每次取消后回到统一初始状态
const getDefaultForm = () => ({
  minFloor: '0',
  totalDoors: '',
  doorType: 'normal',
  openType: 'center',
  carDoorLock: 'no',
  floorDoorNumbers: '',
  // 字符串形态（例如：'轿门/1/2/3A'），便于用户直接编辑
  checkStations: ''
})

export default {
  name: 'FloorSettingDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    initialData: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      dialogVisible: false,
      form: getDefaultForm(),
      floorOptions: []
    }
  },
  watch: {
    visible (val) {
      this.dialogVisible = val
      if (val) {
        this.applyInitialData()
      }
    },
    dialogVisible (val) {
      this.$emit('update:visible', val)
    }
  },
  methods: {
    normalizeCheckStationsText (value) {
      // 兼容两种数据形态：
      // - 旧：数组（下拉多选）
      // - 新：字符串（输入框，使用 / 分隔）
      if (Array.isArray(value)) {
        return this.normalizeFloorList(value).join('/')
      }
      return String(value || '').trim()
    },
    normalizeFloorList (list) {
      if (!Array.isArray(list)) return []
      const unique = new Set()
      list.forEach(item => {
        const value = String(item || '').trim()
        // 不校验层站内容，用户输入什么就保留什么（仅去空、去重）
        if (value) {
          unique.add(value)
        }
      })
      return Array.from(unique)
    },
    // 打开弹窗时回填父组件传入的数据（包含已生成的下拉选项）
    applyInitialData () {
      const defaults = getDefaultForm()
      const normalizedOptions = this.normalizeFloorList(
        Array.isArray(this.initialData.floorOptions)
          ? this.initialData.floorOptions.map(item => (item && item.value !== undefined ? item.value : item))
          : []
      )
      this.form = {
        ...defaults,
        ...this.initialData,
        checkStations: this.normalizeCheckStationsText(this.initialData.checkStations)
      }
      this.floorOptions = normalizedOptions.map(item => ({ label: item, value: item }))
    },
    isPositiveInteger (value) {
      return /^[1-9]\d*$/.test(String(value || '').trim())
    },
    isInteger (value) {
      return /^-?\d+$/.test(String(value || '').trim())
    },
    validateForm () {
      if (!this.isInteger(this.form.minFloor)) {
        this.$message.warning('最低层数必须为整数（支持负数）')
        return false
      }
      if (!this.isPositiveInteger(this.form.totalDoors)) {
        this.$message.warning('层门总数必须为正整数')
        return false
      }
      return true
    },
    // 根据“最低层数 + 层门总数 + 层门类型”生成基础层站编号数组
    buildFloorList () {
      if (!this.validateForm()) return null

      const startFloor = Number(this.form.minFloor)
      const totalDoors = Number(this.form.totalDoors)
      const floorList = []
      let floorNum = startFloor
      let generatedFloors = 0
      while (generatedFloors < totalDoors) {
        if (floorNum === 0) {
          floorNum++
          continue
        }
        const floor = String(floorNum)
        if (this.form.doorType === 'through') {
          floorList.push(`${floor}A`, `${floor}B`)
        } else {
          floorList.push(floor)
        }
        generatedFloors++
        floorNum++
      }
      return floorList
    },
    // 生成“层门编号”字符串与“检查层站”下拉选项
    handleGenerate () {
      const builtList = this.buildFloorList()
      if (!builtList) return
      const floorList = this.normalizeFloorList(builtList)
      // carDoorLock=yes 时，层门编号以轿门开头；贯通门需区分轿门A/轿门B
      const carDoorStations = this.form.doorType === 'through' ? ['轿门A', '轿门B'] : ['轿门']
      const doorStations = this.form.carDoorLock === 'yes'
        ? carDoorStations.concat(floorList.filter(s => !carDoorStations.includes(s)))
        : floorList

      this.form.floorDoorNumbers = doorStations.join('/')
      // 检查层站默认与层门编号一致，用户可手动修改
      this.form.checkStations = this.form.floorDoorNumbers
      this.floorOptions = doorStations.map(item => ({
        label: item,
        value: item
      }))
    },
    // 保存时将完整配置回传给父组件，由父组件负责后续 API 调用
    handleSave () {
      if (!this.validateForm()) return

      const checkStationsList = this.normalizeFloorList(
        String(this.form.checkStations || '')
          .split('/')
          .map(s => String(s || '').trim())
          .filter(s => s)
      )
      this.$emit('confirm', {
        ...this.form,
        // 对外仍保持数组形态，避免影响父组件现有逻辑
        checkStations: checkStationsList,
        floorOptions: this.floorOptions.slice()
      })
      this.dialogVisible = false
    },
    // 取消时重置弹窗内部状态并关闭
    handleCancel () {
      this.form = getDefaultForm()
      this.floorOptions = []
      this.dialogVisible = false
    }
  }
}
</script>

